import { Chat } from '@ai-sdk/react';
import type { ChatInit, ChatTransport } from 'ai';

import type { AskUIMessage } from './askUiMessage';

export type AskChatFinish = Parameters<NonNullable<ChatInit<AskUIMessage>['onFinish']>>[0];
export type AskChatData = Parameters<NonNullable<ChatInit<AskUIMessage>['onData']>>[0];

export function statusTextOf(part: AskChatData): string | null {
  if (part.type !== 'data-status') {
    return null;
  }
  const text = typeof part.data.text === 'string' ? part.data.text.trim() : '';
  return text || null;
}

export function createAskChat({
  transport,
  messages,
  onFinish,
  onData,
}: {
  transport: ChatTransport<AskUIMessage>;
  messages?: Array<AskUIMessage>;
  onFinish?: (event: AskChatFinish) => void;
  onData?: (part: AskChatData) => void;
}): Chat<AskUIMessage> {
  return new Chat<AskUIMessage>({ transport, messages, onFinish, onData });
}
